import React from "react";
import {StyleSheet, TouchableOpacity, View} from "react-native";
import PtText from "../core/pt-text/pt-text";
import {getTranslation} from "../../helpers/getTranslation";
import {styleVars} from "../../app-style-vars";
import {useSelector} from "react-redux";

export default function PtPrivacySettings() {

  const currentLanguage: string = useSelector((state: any) => state.translationsReducer.currentLanguage);

  const showPrivacySettings = () => {
    const privacyComponent = document.getElementsByTagName('dock-privacy-settings')[0];
    const modifiedLocale = currentLanguage.toLowerCase().replace('_', '-');
    privacyComponent?.setAttribute('visible', 'true');
    privacyComponent?.setAttribute('locale', modifiedLocale);
  };

  return (
    <View style={styles.footerLinkContainer}>
      <TouchableOpacity onPress={() => showPrivacySettings()}>
        <PtText style={styles.footerLinkText}>{getTranslation('footer.privacy.settings.link.text')}</PtText>
      </TouchableOpacity>
    </View>
  )
}

const styles = StyleSheet.create({
  footerLinkContainer: {
    paddingHorizontal: styleVars.rem(1),
    paddingVertical: styleVars.rem(.5),
    marginBottom: styleVars.rem(.5),
  },
  footerLinkText: {
    fontSize: styleVars.rem(.875),
    color: styleVars.boschDarkBlue,
  },
});
